import { styled } from "@linaria/react";

const AiEyeIcon = styled.div<{ isLooping?: boolean }>`
  display: flex;
  #pupil {
    animation: pupil_animation 2.5s ease-out ${({ isLooping }) => (isLooping ? "infinite" : "0")};
  }

  #iris {
    animation: iris_animation 2.5s ease-out ${({ isLooping }) => (isLooping ? "infinite" : "0")};
  }

  @keyframes iris_animation {
    0%,
    100% {
      transform: translate(0, 0);
    }
    33% {
      transform: translate(10%, 5%);
    }
    66% {
      transform: translate(7.5%, 2%);
    }
  }

  @keyframes pupil_animation {
    0%,
    100% {
      transform: translate(0, 0);
    }
    33% {
      transform: translate(35%, 0);
    }
    66% {
      transform: translate(17.5%, 10%);
    }
  }
  &.ai-eye-icon-small {
    width: 14px;
    height: 14px;
    & > svg {
      width: 14px;
      height: 14px;
    }
  }
  &.ai-eye-icon-large {
    width: 2.5rem;
    height: 2.5rem;
    & > svg {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
`;

export const AiEyeIconStyle = {
  AiEyeIcon,
};
